<template>
  <div>
    <h1>Ooops 404</h1>
  </div>
</template>

<script>
export default {
  name: "Error404"
}
</script>

<style scoped>

</style>
